import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import selectors from "selectors";
import { fetchChatHistory } from "actions/chat";
import { Page } from "components/ui";
import { useMediaQuery } from "@mui/material";
import ChatHistoryItem from "./chat-history-item";
import ChatHistoryMobileCard from "./chat-history-mobile-card";
import "components/upcoming-chats/upcoming-chats.scss";
import useTranslate from "hooks/use-translate-language";
import useDocumentTitle from "hooks/use-document-title";
import BreadCrumbs from "components/ui_new/breadcrumbs";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";

const ChatHistory = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();
  const chats = useSelector(selectors.getChatHistory);
  const [isFetching, setIsFetching] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width: 900px)");

  // Set document title for accessibility
  useDocumentTitle(translate("appointmentsHistory"));

  useEffect(() => {
    setIsFetching(true);
    dispatch(fetchChatHistory()).finally(() => {
      setIsFetching(false);
    });
  }, [dispatch]);

  return (
    <Page.Container>
      <Page.Header title={translate("appointmentsHistory")} goBack />
      <Page.Content
        isFetching={isFetching}
        isEmpty={chats.length === 0}
        emptyMessage={translate("noChatHistory")}
      >
        <div className="appointments-page-content" id="appointments-history">
          <div className="page-content-header">
            <BreadCrumbs
              childLabel="history"
              parentLink="/upcoming-chats"
              parentLinkLabel="appointments"
              title="appointmentsHistory"
              titleClassname="appointments-title"
            />
          </div>

          {!isSmallScreen ? (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="Chat History Table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">
                      <span id="date-header" className="table-header-title">
                        {translate("date")}
                      </span>
                    </TableCell>
                    <TableCell align="left">
                      <span id="topic-header" className="table-header-title">
                        {translate("topic")}
                      </span>
                    </TableCell>
                    <TableCell align="left">
                      <span id="with-header" className="table-header-title">
                        {translate("with")}
                      </span>
                    </TableCell>
                    <TableCell align="left" aria-hidden="true">
                      <span className="sr-only">Spacer</span>
                    </TableCell>
                    <TableCell align="left" aria-hidden="true">
                      <span className="sr-only">Spacer</span>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {chats.map((chat, index) => {
                    if (
                      chat.chats &&
                      chat.chats[0] &&
                      chat.chats[0].chat_details
                    ) {
                      return <ChatHistoryItem {...chat} key={index} />;
                    }
                    return null;
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <div className="mobile-cards-container">
              {chats.map((chat, index) => {
                if (chat.chats && chat.chats[0] && chat.chats[0].chat_details) {
                  return <ChatHistoryMobileCard key={index} {...chat} />;
                }
                return null;
              })}
            </div>
          )}
        </div>
      </Page.Content>
    </Page.Container>
  );
};

export default ChatHistory;
